// extracted by mini-css-extract-plugin
export default {"balanceHeader":"Balance_balanceHeader__SXN5E","balanceAmounts":"Balance_balanceAmounts__+RyhI","balanceAmountsItem":"Balance_balanceAmountsItem__q+-ji"};